import React from "react";
import './assistbar.scss';
import Button from 'react-bootstrap/Button';


class AssistBar extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          
        }
      }
  render(){

    return (
        <div className={"assistbar-searchcart"}>
        
            <div className={["assistbar-search-container"].join(" ")}>
                <Button className={"find"} onClick={(e)=>{
                    this.props.setval({searchModal:true})
                }}><i className="fa fa-search"></i></Button>
            </div>

            <div className={["assistbar-cart-container"].join(" ")} onClick={(e)=>{
            this.props.setval({currentPage:"shoppingcart"})
            }}>
            
            <Button className="gray"><img src="/assets/shoppingcart.svg" width="30px" />{"  Cart"}</Button>
            {
                (Object.keys(this.props.shoppingCart).length>0)&&
                <div className="assistbar-popcircle">{Object.keys(this.props.shoppingCart).length}</div>
            }
            </div>

      </div>
    );


  }
}

export default AssistBar;
